var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('div',{staticClass:"block"},[_c('el-pagination',{attrs:{"current-page":_vm.per_page,"page-sizes":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }